<div class="theme-toggle">
  <button class="btn btn-link text-secondary text-decoration-none" (click)="toggleTheme()">
    {{ isDarkMode ? '🌙' : '☀️' }}
  </button>
</div>

<router-outlet></router-outlet>